import { css } from 'aphrodite';
import { FC } from 'react';
import { Column, Row } from '../../../../components-v2/PageLayout';
import { THEME, ThemeColors } from '../../../../components-v2/Theme/theme';
import { ButtonBase } from '../../../../components/Button';
import { Popover, PopoverContent, PopoverTrigger } from '../../../../components/Popover';
import { DropDownIcon } from '../../../../components/svgs/icons/DropDownIcon';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../../components/Tooltip';
import { styleSheet } from './styles';

interface ColorPickerProps {
	color?: keyof ThemeColors['pill'];
	onColorChange: (color: keyof ThemeColors['pill']) => void;
	disabled?: boolean;
	disabledMessage?: string;
}

export const ColorPicker: FC<ColorPickerProps> = ({
	color = 'blue',
	onColorChange,
	disabled = false,
	disabledMessage,
}) => {
	const colors = Object.keys(THEME.colors.pill) as (keyof ThemeColors['pill'])[];
	if (color === ('Unknown' as unknown) || color === null) {
		color = 'blue';
	}

	const ColorPickerTrigger = () => {
		return (
			<Row styles={[styleSheet.colorPickerTrigger, disabled && styleSheet.disabledTrigger]}>
				<div
					className={css(styleSheet.colorPickerButton, styleSheet[color.toLowerCase() as keyof typeof styleSheet])}
				/>
				<DropDownIcon fillColor={THEME.colors.icon.gray} />
			</Row>
		);
	};

	return (
		<>
			{disabled && disabledMessage ? (
				<Tooltip>
					<TooltipTrigger className={css(styleSheet.tooltipTriggerFade)}>
						<ColorPickerTrigger />
					</TooltipTrigger>
					<TooltipContent styles={[styleSheet.tooltipContent]}>{disabledMessage}</TooltipContent>
				</Tooltip>
			) : (
				<Popover>
					<PopoverTrigger disabled={disabled}>
						<ColorPickerTrigger />
					</PopoverTrigger>
					<PopoverContent>
						<Column styles={[styleSheet.colorPickerMenu]}>
							{colors.map(colorKey => (
								<ButtonBase
									key={colorKey}
									aria-label={`Select ${colorKey} button`}
									onClick={() => onColorChange(colorKey)}
								>
									<div className={css(styleSheet.colorPickerButton, styleSheet[colorKey])} />
								</ButtonBase>
							))}
						</Column>
					</PopoverContent>
				</Popover>
			)}
		</>
	);
};
